/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('accessWebClient')
    .factory('operationComplete', ['$translate', '$filter', 'flashMessagesService', function ($translate, $filter, flashMessagesService) {
         return function() {
             $translate.apply(null, arguments).then(function (successMessage) {
                 flashMessagesService.add($filter('whiteLabel')(successMessage), flashMessagesService.SUCCESS);
             });
         }
    }]);
 
